import { SessionStore } from './sessionStore'
import { DomainStore } from './domainStore'
import { LocaleStore } from './localeStore'
import { DocumentationStore } from './documentationStore'
import { MessagesStore } from './messagesStore'
import { PersonsStore } from './personsStore'
import { GroupsStore } from './groupsStore'
import { PrivilegeStore } from './privilegeStore'
import { SettingsStore } from './settingsStore'
import { Settings } from './configuratorStore/settings'
import { Files } from './configuratorStore/files'
import { PersonBlanksStore } from './personBlanksStore'
import { GroupPersonsStore } from './groupPersonsStore'

export class Store {
  constructor () {
    this.sessionStore = new SessionStore(this)
    this.domainStore = new DomainStore(this)
    this.localeStore = new LocaleStore()
    this.documentationStore = new DocumentationStore()
    this.configuratorStoreSettings = new Settings(this)
    this.configuratorStoreFiles = new Files(this)
    this.messagesStore = new MessagesStore(this)
    this.privilegeStore = new PrivilegeStore(this)
    this.settingsStore = new SettingsStore()
    this.groupsStore = new GroupsStore(this)
    this.personsStore = new PersonsStore(this)
    this.groupPersonsStore = new GroupPersonsStore(this)
    this.personBlanksStore = new PersonBlanksStore(this)
  }
}
